@use "sass:color";
@use "../../mixins/index.scss" as anchor;

.anchor-c-icon-button {
  /** @prop --icon-button-color: This is the color of the icon itself */
  --icon-button-color: var(--s-color-icon-default);
  /** @prop --icon-button-color-on-dark: Set the color on-dark of the <anchor-icon-button> */
  --icon-button-color-on-dark: var(--s-color-icon-on-dark);
  /** @prop --icon-button-border-radius: Set the border radius of the <anchor-icon-button> */
  --icon-button-border-radius: var(--p-size-static-050);
  /** @prop --icon-button-size: Set the size of the <anchor-icon-button> */
  --icon-button-size: 48px;
  /** @prop --icon-button-padding: Set the padding for <anchor-icon-button> */
  --icon-button-padding: var(--p-size-static-150);
}

.anchor-c-icon-button {
  @include anchor.focus-element;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--icon-button-size);
  height: var(--icon-button-size);
  box-sizing: box-sizing;
  border-radius: var(--icon-button-border-radius);
  background: transparent;
  padding: var(--icon-button-padding);
  cursor: pointer;
  text-decoration: none;
  color: var(--icon-button-color);
  border: none;
  transition: background-color 0.2s ease-in-out;
  -webkit-user-select: none;
  user-select: none;

  &:disabled {
    color: var(--color-cta-disabled-secondary);
    cursor: default;
  }

  &:hover {
    background-color: rgba(34, 34, 34, 0.05);
    /* Black w/ opacity. We use the sass function "transparentize" to be able use our token color with an alpha value
      And therefore we also have to use the scss variable for b.color.black.
    */
    background-color: color.adjust(anchor.$b-color-black, $alpha: -0.95);
  }

  &:active {
    // Override any outline to not be displayed if :active
    --outline-override: none;
    background-color: rgba(34, 34, 34, 0.15);
    /* Black w/ opacity. We use the sass function "transparentize" to be able use our token color with an alpha value
      And therefore we also have to use the scss variable for color.Base.Black.
    */
    background-color: color.adjust(anchor.$b-color-black, $alpha: -0.85);
  }

  &.on-dark {
    --icon-button-color: var(--icon-button-color-on-dark);
    &:focus {
      // Change the width and color of the outline from the default for this variant
      --focus-ring-width: var(--p-size-static-025);
      --focus-ring-color: var(--b-color-white);
    }
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      /* Black w/ opacity. We use the sass function "transparentize" to be able use our token color with an alpha value
        And therefore we also have to use the scss variable for color.Base.Black.
      */
      background-color: color.adjust(anchor.$color-base-white, $alpha: -0.8);
    }
    &:active {
      background-color: rgba(255, 255, 255, 0.4);
      /* Black w/ opacity. We use the sass function "transparentize" to be able use our token color with an alpha value
        And therefore we also have to use the scss variable for color.Base.Black.
      */
      background-color: color.adjust(anchor.$color-base-white, $alpha: -0.6);
    }
  }
}
